/**
 * YAF v3 — Canvas Particle Effects
 * Supports: wave, spiral, terrain, cluster, field, vortex
 */
document.querySelectorAll('.hero-canvas').forEach(function(canvas) {
  var ctx = canvas.getContext('2d');
  var form = canvas.getAttribute('data-effect') || 'wave';
  var section = canvas.closest('.yaf-hero');
  var w = 0, h = 0, t = 0;
  var hasLines = (form === 'wave' || form === 'terrain');
  var COLS = 70, ROWS = 45;

  function measure() {
    if (!section) return;
    var rect = section.getBoundingClientRect();
    if (rect.width > 10 && rect.height > 10) {
      w = Math.round(rect.width);
      h = Math.round(rect.height);
      canvas.width = w;
      canvas.height = h;
    }
  }

  function getZ(bx, by) {
    var cx = w/2, cy = h/2;
    var dx = bx - cx, dy = by - cy;
    var dist = Math.sqrt(dx*dx + dy*dy);
    var maxD = Math.sqrt(cx*cx + cy*cy);
    var nd = maxD > 0 ? dist / maxD : 0;
    if (form === 'wave') return Math.sin(t*0.8+bx*0.008+by*0.006)*60+Math.cos(t*0.5+bx*0.005-by*0.009)*40;
    if (form === 'spiral') { var a=Math.atan2(dy,dx); return Math.sin(a*3+dist*0.02-t*1.0)*(70-nd*30); }
    if (form === 'terrain') return Math.sin(bx*0.01+t*0.4)*50+Math.cos(by*0.012+t*0.3)*40+Math.sin((bx+by)*0.007+t*0.6)*20;
    if (form === 'cluster') { var fo=Math.exp(-nd*2.0); return Math.sin(t*0.8+dist*0.015)*80*fo; }
    if (form === 'field') return Math.sin(t*0.5+bx*0.005)*25+Math.cos(t*0.4+by*0.006)*18;
    if (form === 'vortex') { var a2=Math.atan2(dy,dx); return Math.sin(a2*2+dist*0.025-t*1.2)*(80-nd*40)+Math.cos(t*0.8+dist*0.01)*30; }
    return Math.sin(t*0.8+bx*0.008)*40;
  }

  function frame() {
    if (w < 10 || h < 10) { measure(); requestAnimationFrame(frame); return; }
    t += 0.016;
    ctx.clearRect(0, 0, w, h);
    var sx = w/(COLS-1), sy = h/(ROWS-1);
    var cx = w/2, cy = h/2, maxD = Math.sqrt(cx*cx+cy*cy);
    var pts = [];
    for (var r = 0; r < ROWS; r++) {
      pts[r] = [];
      for (var c = 0; c < COLS; c++) {
        var bx = c*sx, by = r*sy;
        var z = getZ(bx, by);
        var zn = (z+80)/160;
        if (zn < 0) zn = 0; if (zn > 1) zn = 1;
        var op = 0.01+zn*0.25;
        var rad = 0.4+zn*1.2;
        var efx = Math.min(bx, w-bx)/(w*0.25);
        var efy = Math.min(by, h-by)/(h*0.25);
        var ef = Math.min(1, efx, efy);
        var shX = maxD>0 ? z*0.7*(bx-cx)/maxD : 0;
        var shY = maxD>0 ? z*0.7*(by-cy)/maxD : 0;
        pts[r][c] = {x:bx+shX, y:by+shY, r:rad, o:op*ef};
      }
    }
    if (hasLines) {
      ctx.lineWidth = 0.3;
      for (var r = 0; r < ROWS; r++) {
        for (var c = 0; c < COLS-1; c++) {
          var a = pts[r][c], b = pts[r][c+1];
          var lo = (a.o+b.o)*0.2;
          if (lo > 0.002) { ctx.beginPath(); ctx.moveTo(a.x,a.y); ctx.lineTo(b.x,b.y); ctx.strokeStyle='rgba(245,240,232,'+lo+')'; ctx.stroke(); }
        }
      }
    }
    for (var r = 0; r < ROWS; r++) {
      for (var c = 0; c < COLS; c++) {
        var p = pts[r][c];
        if (p.o > 0.003) { ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,6.28); ctx.fillStyle='rgba(245,240,232,'+p.o+')'; ctx.fill(); }
      }
    }
    requestAnimationFrame(frame);
  }

  measure();
  window.addEventListener('resize', measure);
  requestAnimationFrame(frame);
});
